import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { useCallDeafParticipantHandlers } from 'features/call/call-accepted/hooks';
import {
  deafPhoneNumberSelector,
  isDeafConnectedSelector,
  selectDeafConnectionWasNotAttempted,
} from 'features/call/call-deaf/store';
import { isPrimaryHearingConnectedSelector } from 'features/call/call-hearing/store';
import { isDeafAutoConnectEnabledSelector } from 'features/call/vrs-call/store/vrsCallSelectors';
import { isHearingToDeafSelector } from 'features/call/call-base/store/selectors';
import { sendAnalyticsInfo } from 'features/analytics/helpers';

export const useDeafAutoConnectForHearingToDeafCall = () => {
  const { handleDeafConnect } = useCallDeafParticipantHandlers();
  const deafPhoneNumber = useAppSelector(deafPhoneNumberSelector);
  const isDeafAutoConnectEnabled = useAppSelector(
    isDeafAutoConnectEnabledSelector
  );
  const dispatch = useAppDispatch();
  const isDeafConnected = useAppSelector(isDeafConnectedSelector);
  const isHearingConnected = useAppSelector(isPrimaryHearingConnectedSelector);
  const deafConnectionWasNotAttempted = useAppSelector(
    selectDeafConnectionWasNotAttempted
  );
  const isHearingToDeafCall = useAppSelector(isHearingToDeafSelector);

  useEffect(() => {
    if (isDeafConnected || !isHearingToDeafCall) {
      return;
    }

    if (
      isDeafAutoConnectEnabled &&
      isHearingConnected &&
      deafConnectionWasNotAttempted
    ) {
      dispatch(
        sendAnalyticsInfo({
          Method: 'useDeafAutoConnectForHearingToDeafCall',
          Message: 'Auto connect deaf for H2D call',
        })
      );
      handleDeafConnect(deafPhoneNumber);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHearingConnected]);
};
